import React, { useEffect, useMemo, useState } from "react";
import { Skeleton, useDevice } from "design_system/src";
import styles from "./RecommendedVehiclesSkeleton.module.scss";

const RecommendedVehiclesSkeleton: React.FC = () => {
  const {
    isTablet: isTabletDevice,
    isDesktop: isDesktopDevice,
    isLoading
  } = useDevice();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [isDesktop, setIsDesktop] = useState<boolean>();
  const skeletonCount = useMemo(() => {
    if (isMobile) {
      return 2;
    }
    if (isDesktop) {
      return 5;
    }
    return 3;
  }, [isMobile, isDesktop]);

  useEffect(() => {
    if (!isLoading) {
      setIsDesktop(isDesktopDevice && !isTabletDevice);
      setIsMobile(!isDesktopDevice && !isTabletDevice);
    }
  }, [isTabletDevice, isDesktopDevice, isLoading]);

  const renderSkeletonItem = (index: number) => (
    <div key={index} className={styles.skeletonItem}>
      {/* Label del vehículo */}
      <div className={styles.labelContainer}>
        <Skeleton
          width="60%"
          height={20}
          className={styles.labelSkeleton}
        />
        <Skeleton
          width={16}
          height={16}
          className={styles.iconSkeleton}
        />
      </div>

      {/* Imagen del vehículo */}
      <Skeleton
        width="100%"
        height={150}
        className={styles.imageSkeleton}
      />

      {/* Precio */}
      <Skeleton
        width="80%"
        height={14}
        className={styles.priceSkeleton}
      />

      {/* Marca y modelo */}
      <Skeleton
        width="70%"
        height={10}
        className={styles.brandSkeleton}
      />

      {/* Botón */}
      <Skeleton
        width="100%"
        height={30}
        className={styles.buttonSkeleton}
      />
    </div>
  );

  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: skeletonCount }, (_, index) => renderSkeletonItem(index))}
    </div>
  );
};

export default RecommendedVehiclesSkeleton;
